import { render } from "./TablePresentations.vue?vue&type=template&id=8fbfbb9a"
import script from "./TablePresentations.vue?vue&type=script&lang=js"
export * from "./TablePresentations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__